const getFullyQualifiedFieldName = (item, name) => (item ? `${item}.${name}` : name);

export default getFullyQualifiedFieldName;
